import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/zebra/Template'

const Zebra: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 CRM PUSH 通知 配信'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/cases/zebra/'}
        title="ZEBRA | 事例 | Aitria（アイトリア）"
        description="ZEBRAのケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Zebra
